<div class="col-lg-12">
  <div class="row">
    <div *ngFor="let provider of providers" class="col-lg-4 detail-con">
      <p-table [scrollable]="true"
               scrollHeight="700px" [value]="provider.datacenters" [rowHover]="true"
               [lazy]="false">
        <ng-template pTemplate="header">
          <tr>
            <th colspan="8">
              <div class="flex justify-content-between align-items-center">
                {{provider.name}}
                @if (polygonsSourceData.get(provider.id)) {
                  <i class="pi pi-circle-fill ml-2" [style]="{color: polygonsSourceData.get(provider.id).polygon.properties.color}"></i>
                }
              </div>
            </th>
          </tr>
          <tr class="header-detail">
            <th rowspan="2" style="width:5%;">
              <div class="flex justify-content-between align-items-center">
                ID
              </div>
            </th>
            <th rowspan="2" style="width:15%;">
              <div class="flex justify-content-between align-items-center">
                Building
              </div>
            </th>
            <th colspan="3" style="width:30%;">
              <div class="flex justify-content-between align-items-center">
                MW
              </div>
            </th>
            <th rowspan="2" style="width:10%;">
              <div class="flex justify-content-between align-items-center">
                Year Live
              </div>
            </th>
            <th rowspan="2" style="width:25%;">
              <div class="flex justify-content-between align-items-center">
                City
              </div>
            </th>
            <th rowspan="2" style="width:15%;">
              <div class="flex justify-content-between align-items-center">
                Building Tenant
              </div>
            </th>
          </tr>
          <tr class="header-detail">
            <th style="width:10%;">
              <div class="flex justify-content-between align-items-center">
                Live
              </div>
            </th>
            <th style="width:10%;">
              <div class="flex justify-content-between align-items-center">
                U/C
              </div>
            </th>
            <th style="width:10%;">
              <div class="flex justify-content-between align-items-center">
                Plan
              </div>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-building>
          <tr (click)="goToLocation(building)" class="p-selectable-row">
            <td>
              <span [class]="provider.base64Icon ? 'dot dot-with-image' : 'dot dot-with-image'"
                    [style.backgroundImage]="datacenterProviders.get(building.provider).backgroundImage"
                    [style.backgroundColor]="datacenterProviders.get(building.provider).color"
                    [style.color]="'#000000'">
                {{!provider.base64Icon ? building.label : ''}}
              </span>
            </td>
            <td>
              {{building.building}}
            </td>
            <td>
              {{building.mwLive || 0}}
            </td>
            <td>
              {{building.mwUC || 0}}
            </td>
            <td>
              {{building.mwPlanned || 0}}
            </td>
            <td>
              {{building.firstYearOp}}
            </td>
            <td>
              {{building.market}}
            </td>
            <td>
              {{building.buildingTenant}}
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="footer">
          <tr>
            <td>Total</td>
            <td></td>
            <td style="text-align: center"></td>
            <td style="text-align: center"></td>
            <td style="text-align: center"></td>
            <td class="text-right"></td>
            <td class="text-right"></td>
            <td class="text-right"></td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
